"use client";

import { forwardRef, type InputHTMLAttributes } from "react";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

const INPUT_CLASSES =
  "w-full rounded-[var(--fz-field-radius)] border border-[var(--fz-field-border)] bg-[var(--fz-field-bg)] px-3 py-2.5 text-sm text-[var(--fz-field-text)] outline-none transition-colors placeholder:text-[var(--fz-field-placeholder)] hover:border-[var(--fz-field-border-hover)] focus-visible:border-[var(--fz-field-border-focus)] focus-visible:ring-2 focus-visible:ring-[var(--fz-field-focus-ring)] focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:bg-[var(--fz-field-disabled-bg)] disabled:text-[var(--fz-field-disabled-text)] read-only:bg-[var(--fz-field-readonly-bg)] aria-invalid:border-[var(--fz-field-error)] aria-invalid:focus-visible:border-[var(--fz-field-error)] aria-invalid:focus-visible:ring-[var(--fz-field-error)]";

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className = "", ...props },
  ref,
) {
  return <input {...props} ref={ref} data-fz-field="input" className={`${INPUT_CLASSES} ${className}`} />;
});
